import React, { useState, useEffect, useRef } from 'react'
import { Typography } from '@mui/material'
import { editInputStyle, restoreButtonStyle, editableTypographyStyle, getEditedCellStyle } from '../styles'

const EditableNSCell = ({ 
  cell, 
  row, 
  onEdit, 
  onRestore, 
  isEdited 
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editValue, setEditValue] = useState(cell.getValue())
  const inputRef = useRef(null)
  
  const handleEdit = () => setIsEditing(true)
  
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
      // Posicionar cursor al final
      const len = inputRef.current.value.length
      inputRef.current.setSelectionRange(len, len)
    }
  }, [isEditing])
  
  const handleSave = () => {
    const numValue = parseFloat(editValue)
    
    // Validar rango
    if (numValue >= 0.8 && numValue <= 1.0) {
      // Valor válido - llamar al endpoint
      onEdit(editValue, row.original, 'nsEscogido')
      setIsEditing(false)
    } else {
      // Valor fuera de rango - mostrar error y revertir
      alert('Error: El NS debe estar entre 0.8 y 1.0')
      setEditValue(cell.getValue())
      setIsEditing(false)
    }
  }
  
  const handleCancel = () => {
    setEditValue(cell.getValue())
    setIsEditing(false)
  }
  
  const handleInputChange = (e) => {
    const inputValue = e.target.value
    const numericRegex = /^[0-9]*\.?[0-9]{0,2}$/
    if (numericRegex.test(inputValue) || inputValue === '') {
      setEditValue(inputValue)
    }
  }
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSave()
    }
    if (e.key === 'Escape') {
      e.preventDefault()
      handleCancel()
    }
  }

  const handleRestoreClick = (e) => {
    e.stopPropagation()
    onRestore(row.original.modeloPlaneacion)
  }
  
  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={editValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={handleCancel}
        style={editInputStyle}
      />
    )
  }
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {isEdited && (
        <button
          type="button"
          onClick={handleRestoreClick}
          style={restoreButtonStyle}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f5f5f5'
            e.target.style.color = '#333'
          }}
          onFocus={(e) => {
            e.target.style.backgroundColor = '#f5f5f5'
            e.target.style.color = '#333'
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent'
            e.target.style.color = '#666'
          }}
          onBlur={(e) => {
            e.target.style.backgroundColor = 'transparent'
            e.target.style.color = '#666'
          }}
          title="Restaurar valor original"
        >
          ↶
        </button>
      )}
      <Typography 
        variant="body2"
        sx={{
          ...getEditedCellStyle(isEdited),
          ...editableTypographyStyle
        }}
        onClick={handleEdit}
        title="Click para editar (Enter: guardar, Esc/Click fuera: cancelar)"
      >
        {(Number(cell.getValue()) * 100).toFixed(2)}%
      </Typography>
    </div>
  )
}

export default EditableNSCell 